// Утилиты для санитизации пользовательского ввода перед рендером в UI.
// React сам экранирует HTML, поэтому XSS через innerHTML невозможен,
// но layout-DoS через unicode RTL-override / ZWJ / просто длинные строки
// возможен. Этот модуль защищает от таких атак.

import { DISPLAY_NAME_MAX_CHARS } from "@/api/constants";

/**
 * Безопасное отображаемое имя пользователя.
 * - Удаляет unicode control-символы (RTL-override `‮`, LTR-override `‭`,
 *   ZWJ `‍`, ZWNJ `‌`, BOM `﻿`, NULL ` ` и др.).
 * - Обрезает до DISPLAY_NAME_MAX_CHARS символов (с многоточием при truncation).
 * - Возвращает пустую строку для null/undefined/non-string.
 */
export function sanitizeDisplayName(raw: unknown): string {
  if (typeof raw !== "string") return "";
  // Удаляем unicode control chars (категории Cc, Cf, Co, Cn) и bidi-override.
  // Этот regex покрывает основные опасные символы; полная Unicode-categorization
  // не нужна — достаточно phishing-relevant chars.
  const stripped = raw.replace(
    // eslint-disable-next-line no-control-regex
    /[ --​-‏‪-‮⁦-⁩﻿]/g,
    "",
  );
  const trimmed = stripped.trim();
  if (trimmed.length <= DISPLAY_NAME_MAX_CHARS) return trimmed;
  return trimmed.slice(0, DISPLAY_NAME_MAX_CHARS - 1) + "…";
}
